import React from 'react';

export const OurApproach: React.FC = () => {
  const approaches = [
    {
      title: 'Transparent Communication',
      description: 'We believe in complete honesty throughout the entire transaction. From our initial conversation to the final closing, you will always know exactly where you stand. We provide clear explanations of our valuation process, answer all your questions promptly, and keep you informed at every step. No hidden agendas, no surprise changes, just straightforward communication that builds trust and confidence.',
      icon: 'ri-message-3-line'
    },
    {
      title: 'Fair Market Valuations',
      description: 'Our team conducts thorough property assessments using industry-standard methodologies. We analyze comparable sales, review your income statements, evaluate property condition, and consider current market trends. This comprehensive approach ensures you receive a fair offer that reflects the true value of your apartment building. We take pride in making offers that sellers can feel good about accepting.',
      icon: 'ri-scales-3-line'
    },
    {
      title: 'Flexible Solutions',
      description: 'Every seller has unique circumstances and goals. Whether you need to close quickly due to financial pressures, want to time the sale for tax purposes, or need creative financing arrangements, we work with you to structure a deal that meets your specific needs. Our flexibility extends to closing dates, possession terms, and even seller financing options when appropriate.',
      icon: 'ri-settings-3-line'
    },
    {
      title: 'Professional Service',
      description: 'Working with us means working with experienced real estate professionals who understand the complexities of apartment building transactions. We handle all the details, coordinate with attorneys and title companies, manage inspections and due diligence, and ensure a smooth closing process. Our goal is to make selling your property as stress-free as possible while protecting your interests throughout.',
      icon: 'ri-award-line'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Approach to Buying Apartment Buildings
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We have built our reputation on integrity, professionalism, and delivering results. When you work with us, you can expect a buying experience that prioritizes your needs and respects your timeline.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {approaches.map((approach, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className={`${approach.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {approach.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {approach.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl p-12">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Experience the Difference
            </h3>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Unlike traditional buyers who may drag out negotiations or back out at the last minute, we are committed to following through on our commitments. When we make an offer, we stand behind it. When we set a closing date, we meet it. This reliability gives you the peace of mind to plan your next steps with confidence, knowing that your sale will proceed as agreed.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our approach has earned us the trust of hundreds of apartment building owners who have chosen to work with us instead of listing with agents or dealing with uncertain buyers. We invite you to experience the same level of service and professionalism that has made us a preferred buyer in the market.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
